import WildAppResource from "./WildAppResource";
import FormAppResource from "./FormAppResource";

class JotFormAnswerAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'jot-form-answer';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'jots/forms/answers';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'submissionId',
            'jotFormInputId',
            'jotFormInputName',
            'answer',
            'formUuid',
            'form',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            form: FormAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            form: 'form_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {};
    }

}

export default JotFormAnswerAppResource;
